import Reveal from "@/components/base/Reveal";
import SectionHead from "@/components/base/SectionHead";
import { hotList, relatedLinks } from "@/mocks/dailyContest";

export default function Trending() {
  return (
    <section id="hot" className="border-b border-background-300/70 bg-background-100 py-12 md:py-16">
      <div className="container-x">
        <div className="grid gap-10 lg:grid-cols-12">
          {/* main hot list */}
          <div className="lg:col-span-8">
            <Reveal>
              <SectionHead
                eyebrow="热搜 · 实时刷新"
                title="今天全站都在吃这些瓜"
                desc="榜单综合公开票池、官方榜单与社交平台讨论度整理，每小时更新一次，热度标记随讨论量浮动。"
              />
            </Reveal>

            <ol className="mt-8 divide-y divide-background-300/70">
              {hotList.map((item, i) => (
                <Reveal key={item.rank} delay={i * 40}>
                  <li className="group flex items-center gap-4 py-4 transition-colors">
                    <span
                      className={`headline-en w-9 shrink-0 text-right text-3xl font-black leading-none ${
                        item.rank <= 3 ? "text-primary-500" : "text-foreground-300"
                      }`}
                    >
                      {String(item.rank).padStart(2, "0")}
                    </span>
                    <div className="min-w-0 flex-1">
                      <a
                        href="#gossip"
                        className="block cursor-pointer text-[15px] font-semibold leading-6 text-foreground-900 transition-colors hover:text-primary-600 md:text-base"
                      >
                        {item.title}
                      </a>
                      <span className="mt-1 inline-flex items-center gap-2 text-xs text-foreground-500">
                        <i className="ri-price-tag-3-line" aria-hidden="true" />
                        {item.tag}
                      </span>
                    </div>
                    <span
                      className={`shrink-0 rounded-sm px-2 py-1 text-[11px] font-bold ${
                        item.mark === "爆"
                          ? "bg-primary-500 text-background-50"
                          : item.mark === "热"
                            ? "bg-accent-500 text-background-50"
                            : "bg-secondary-200 text-secondary-800"
                      }`}
                    >
                      {item.mark}
                    </span>
                  </li>
                </Reveal>
              ))}
            </ol>

            <Reveal delay={120}>
              <p className="mt-2 flex items-center gap-2 text-xs text-foreground-500">
                <i className="ri-time-line" aria-hidden="true" />
                榜单数据截至今日 20:00，为公开信息整理，不代表官方立场
              </p>
            </Reveal>
          </div>

          {/* sidebar */}
          <aside className="lg:col-span-4">
            <Reveal delay={100}>
              <div className="rounded-lg border border-background-300/70 bg-background-50 p-6">
                <h3 className="font-serif text-lg font-bold text-foreground-950">栏目速览</h3>
                <p className="mt-1 text-[13px] leading-6 text-foreground-500">
                  站内常用专题入口，按主题直达对应深度内容。
                </p>
                <ul className="mt-5 space-y-2">
                  {relatedLinks.map((r) => (
                    <li key={r.title}>
                      <a
                        href="#about"
                        className="group flex items-center gap-3 rounded-md border border-transparent px-3 py-2.5 transition-colors hover:border-primary-200 hover:bg-background-50 hover:text-primary-600"
                      >
                        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                          <i className={`${r.icon} text-base`} aria-hidden="true" />
                        </span>
                        <span className="min-w-0">
                          <span className="block truncate text-sm font-semibold text-foreground-800 group-hover:text-primary-600">
                            {r.title}
                          </span>
                          <span className="block truncate text-xs text-foreground-500">{r.desc}</span>
                        </span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>

            <Reveal delay={160}>
              <div className="mt-6 rounded-lg border border-accent-200/70 bg-accent-50 p-6">
                <div className="flex items-center gap-2 text-accent-600">
                  <i className="ri-megaphone-fill text-base" aria-hidden="true" />
                  <h3 className="text-sm font-bold">本周热议小结</h3>
                </div>
                <p className="mt-3 text-[13px] leading-6 text-foreground-700">
                  导师点评删改、数据异常与保送条款成为本周讨论量前三的主题。观点与事实已分别标注，
                  去对应板块细看完整证据链吧。
                </p>
                <a
                  href="#mentor"
                  className="mt-4 inline-flex cursor-pointer items-center gap-1 text-sm font-bold text-accent-600 hover:text-accent-700"
                >
                  前往导师点评板块
                  <i className="ri-arrow-right-line" aria-hidden="true" />
                </a>
              </div>
            </Reveal>
          </aside>
        </div>
      </div>
    </section>
  );
}